import React, { memo } from "react";
import { Box, TextField, Typography, Grid } from "@mui/material";

const VehicleFinancierDetailsForm = memo(({ register, errors, disabled }) => {
  return (
    <Box>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 3, color: "#1f2937" }}
      >
        Vehicle Financier Details
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Vehicle Financier Name"
            {...register("vehicleFinancierName")}
            error={!!errors.vehicleFinancierName}
            helperText={errors.vehicleFinancierName}
            placeholder="Enter financier name"
            variant="outlined"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Vehicle Financier Phone Number"
            {...register("vehicleFinancierPhone")}
            error={!!errors.vehicleFinancierPhone}
            helperText={
              errors.vehicleFinancierPhone
            }
            placeholder="Enter phone number"
            variant="outlined"
            inputProps={{ maxLength: 10 }}
            disabled={disabled}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Vehicle Financier Address"
            {...register("vehicleFinancierAddress")}
            error={!!errors.vehicleFinancierAddress}
            helperText={errors.vehicleFinancierAddress}
            placeholder="Enter financier address"
            variant="outlined"
            multiline
            rows={3}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </Box>
  );
});

export default VehicleFinancierDetailsForm;
